((): void => {
  const footerClassName = '.footer';
  const footerColumnHeaderClassName = '.footer__column__header';
  const expandClassName = 'expand';
  const collapseSelectorAttribute = 'data-collapse-selector';
  const footer: HTMLDivElement | null = document.querySelector(footerClassName);

  if (!footer) return;

  const footerColumnHeaderItems: HTMLElement[] = Array.from(footer.querySelectorAll(footerColumnHeaderClassName));

  const addEventListeners = (): void => {
    footerColumnHeaderItems.forEach((element) => {
      element.addEventListener('click', ($event) => {
          const collapseSelector = element.getAttribute(collapseSelectorAttribute);
          const collapseElement = footer.querySelector<HTMLElement>(collapseSelector);

          collapseElement.classList.toggle(expandClassName);
          $event.stopPropagation();
      });
    });
  };

  addEventListeners();
})();
